import Cookies from 'js-cookie';
import { atom, useAtom } from 'jotai';
import { SUBSCRIPTION } from '../constants/general';

export type User = {
  userId: string;
  email: string;
  subscription?: SUBSCRIPTION;
  dateStyle?: string;
  isVerified?: boolean;
  JSESSIONID?: string;
  [key: string]: unknown;
};

const defaultUser: User = {
  userId: '',
  email: '',
  subscription: SUBSCRIPTION.BASIC,
  dateStyle: 'MMMM dd yyyy',
};

export const userAtom = atom<User>(defaultUser);

export const userSubscriptionAtom = atom(get => get(userAtom).subscription);

export const useUserAtom = () => {
  const [user, setUser] = useAtom(userAtom);

  return {
    user,
    setUser,
    updateUser: (u: Partial<User>) => setUser({ ...user, ...u }),
    login: (u: User) => {
      setUser(u);
    },
    logout: () => {
      Cookies.remove('site', {
        path: '/',
        domain: new URL(document.location.href).hostname,
      });
      setUser(defaultUser);
    },
  };
};

export const useUserSubscription = () => {
  const [level] = useAtom(userSubscriptionAtom);
  return {
    hasPermission: (p: SUBSCRIPTION[] | SUBSCRIPTION) =>
      (Array.isArray(p) ? p : [p]).includes((level as unknown) as SUBSCRIPTION),
  };
};
